import { WithRequiredProperty } from './WithRequiredProperty';

type FormatCurrencyOptions = {
  onZero?: string | number;
  locale?: string;
} & WithRequiredProperty<Intl.NumberFormatOptions, 'currency'>;

export const formatCurrency = (
  number: number,
  options: FormatCurrencyOptions,
): string => {
  const onZero = options.onZero;
  if (!number && onZero) {
    return String(onZero);
  }

  const locale = options.locale || 'en-US';

  delete options.onZero;
  delete options.locale;

  return new Intl.NumberFormat(locale, {
    ...options,
    style: 'currency',
  }).format(number);
};

export const currencySymbol = (currency: string, locale: string = 'en-US'): string | null => {
  const currencyObj = Intl
    .NumberFormat(locale, { style: 'currency', currency })
    .formatToParts(0)
    .find(({ type }) => type === 'currency');

  if (!currencyObj) {
    return null;
  }

  return currencyObj.value;
};

export const HARD_CODED_USD_CHANGE_ME = 'USD' as const;
